<template>
  <div>
    <h2>About Lenore</h2>
    <img class="hand-drawn mobile-show" src='../assets/third_at_piano.jpg'/>
    <p>
      <img class="mobile-hide" src='../assets/third_at_piano.jpg'/>
      Hi, I am Lenore. I’ve been in love with the piano since I was two. At four, my parents started me with lessons.
      Playing the piano -- along with guitar, violin and clarinet -- was always a wonderful, fully enjoyable part of my
      life.
      <br/>
    </p>
    <p>
      At UCLA, I majored in Music and Ethnomusicology, taking both piano and guitar from excellent teachers.
      I enjoyed being exposed to music from many parts of the world, from Africa to Bali,
      and my appreciation of the wonderful world of music grew enormously.
      <br/>
    </p>

    <p>
      Having come from a family of educators, I began tutoring a variety of students during my college years.
      I was able to help with many academic subjects. When I began teaching piano, I loved it immediately.
      I taught at my students’ homes at first, and later moved my studio to my home, as I raised my three children.
      My husband taught guitar in another room, and we had a lively,
      active home full of children and friends, students and parents, for many years.
      <br/>
    </p>


    <p>
      As our children grew up, my husband and I moved to a cottage in the country.
      I am now teaching online, and I love it! I still cherish the warm, fun environment my students enjoyed in my
      old home studio, and I nurture a similar atmosphere with my online connections.
      <br/>
    </p>

    <p>
      I encourage anyone who is interested or curious to call or text me and we can set up a free meeting via Zoom
      where you can see my setup and we can get to know one another.
      <br/>
    </p>


  </div>
</template>

<script>
export default {
  name: "About"
}
</script>

<style scoped>

img.mobile-hide {
  float: right;
  width: 40%;
  height: 100%;
  margin-right: 20px;
}
</style>